export var DEPLOY_DATE = new Date('2026-07-09T18:42:19+0000');
